import Auth from "@system/config/auth";
import Api from "src/service/APIHandler";

const API = new Api({});

class DesignHubAPICall {

    registerUser = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        try {
            await API.post(Auth.REGISTER_USER_URL, param).then((resHer) => {
                if (resHer.data) {
                    res = resHer?.data
                }
            });
        } catch (e) {
            res = e?.response?.data
        }
        return res;
    };
}

export default DesignHubAPICall;